// extracted by mini-css-extract-plugin
module.exports = {"common__title":"style_common__title__A3Nbm"};